import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import moment from 'moment';
import Swal from 'sweetalert2';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const InstituteAnnouncements = () => {
    const instituteMasterId = localStorage.getItem("instituteMasterId");
    const authorizedAxiosIntitute = generateAxiosInstanceInstitute();
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload();
    const today = new Date().toISOString().split("T")[0];
    const [tagName, setTagName] = useState('');
    const [tagDescription, setTagDescription] = useState('');
    const [tagLastDate, setTagLastDate] = useState('');
    const [announcementList, setAnnouncementList] = useState([]);
    const [editId, setEditId] = useState(null);
    const [error, setError] = useState('');
    const [errord, setErrord] = useState('');
    const [errorT, setErrorT] = useState('');

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [titleSort, setTitleSort] = useState(null);
    const [announcementSort, setAnnouncementSort] = useState(null);
    const [dateSort, setDateSort] = useState(null);
    const [expiryDateSort, setExpiryDateSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["title", "content", "createdAt", "expiryDate"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getAnnouncement();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getAnnouncement();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setAnnouncementList(await searchArray("I", `/get-institute-announcement?instituteMasterId=${instituteMasterId}`, searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(announcementList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(announcementList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > announcementList.length) {
            endIndex = announcementList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(announcementList.slice(startIndex, endIndex));
    }, [announcementList, currPage, itemsPerPage]);

    const getAnnouncement = async () => {
        try {
            const apiUrl = `/get-institute-announcement?instituteMasterId=${instituteMasterId}`;
            const response = await authorizedAxiosIntitute.get(apiUrl)
            setAnnouncementList(response.data.result)
        } catch (error) {
            setAnnouncementList([])
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    useEffect(() => {
        if (tagName !== '') {
            setError('')
        }
        if (tagDescription !== '') {
            setErrord('')
        }
        if (tagLastDate !== '') {
            setErrorT('')
        }
    }, [tagName, tagDescription, tagLastDate])

    const addAnnouncement = async () => {
        if (tagName !== '' && tagDescription !== '') {
            try {
                setLoading(true);
                const apiUrl = `/add-institute-announcement`;
                const response = await authorizedAxiosIntitute.post(apiUrl, {
                    instituteMasterId,
                    title: tagName,
                    content: tagDescription,
                    expiryDate: tagLastDate
                })
                await getAnnouncement();
                setTagName('')
                setTagDescription('')
                setTagLastDate('')

                setSaveId(response.data.result.id);
                setTitleSort(null);
                setAnnouncementSort(null);
                setDateSort(null);
                setExpiryDateSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            if (tagName == '') {
                setError("This field is required.")
            }
            if (tagDescription == '') {
                setErrord("This field is required.")
            }
            if (tagLastDate == '') {
                setErrorT("This field is required.")
            }
        }
    }

    const deleteAnnouncement = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-announcement?id=${id}`;
                const response = await authorizedAxiosIntitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, announcementList.length);
                await getAnnouncement();
                setCurrPage(page);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateAnnouncement = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-institute-announcement?id=${editId}`;
            const response = await authorizedAxiosIntitute.put(apiUrl, {
                instituteMasterId,
                title: tagName,
                content: tagDescription,
                expiryDate: tagLastDate
            })
            await getAnnouncement();
            setEditId(null);
            setTagName('')
            setTagDescription('')
            setTagLastDate('')
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    const handleChange = (editor) => {
        const value = editor.getData();
        setTagDescription(value);
    };

    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    setLoading(true);
                    loader.file.then(async (file) => {
                        body.append("file", file);
                        const apiUrl = "uploadimage";
                        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                            .then((res) => {
                                resolve({ default: res.data.result });
                            })
                            .catch((err) => {
                                reject(err?.response?.data?.error);
                            })
                            .finally(() => {
                                setLoading(false); // End loading
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    useEffect(() => {
        if (titleSort == true || titleSort == false) {
            setAnnouncementSort(null);
            setDateSort(null);
            setExpiryDateSort(null);
        }
    }, [titleSort])

    useEffect(() => {
        if (announcementSort == true || announcementSort == false) {
            setTitleSort(null);
            setDateSort(null);
            setExpiryDateSort(null);
        }
    }, [announcementSort])

    useEffect(() => {
        if (dateSort == true || dateSort == false) {
            setTitleSort(null);
            setAnnouncementSort(null);
            setExpiryDateSort(null);
        }
    }, [dateSort])

    useEffect(() => {
        if (expiryDateSort == true || expiryDateSort == false) {
            setTitleSort(null);
            setAnnouncementSort(null);
            setDateSort(null);
        }
    }, [expiryDateSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Institute Announcements</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-bullhorn"></i> Institute Announcements</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-12 board_name mt-3 mb-3">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Title</label>
                                                    <input type="text" className="form-control" id="gradeName" value={tagName} onChange={(e) => setTagName(e.target.value)} />
                                                    {error && <p style={{ color: 'red' }}>{error}</p>}
                                                </div>
                                                <div className="col-md-12 board_name">

                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Announcements</label>
                                                    {/* <input type="text" className="form-control" id="gradeName2" name='2' value={tagDescription} onChange={(e) => setTagDescription(e.target.value)} /> */}
                                                    {/* <CKEditor
                                                        editor={ClassicEditor}
                                                        data={tagDescription}
                                                        onChange={(event, editor) => handleChange(editor)}
                                                        config={{ extraPlugins: [uploadPlugin] }}
                                                        onInit={(editor) => uploadPlugin(editor)}
                                                    /> */}
                                                    <div
                                                        style={{
                                                            width: 'calc(100% - 290px)',
                                                            // padding: '0.375rem 0.75rem',
                                                            paddingLeft: 0,
                                                        }}
                                                    >
                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            data={tagDescription}
                                                            onChange={(event, editor) => handleChange(editor)}
                                                            config={{ extraPlugins: [uploadPlugin] }}
                                                            onInit={(editor) => uploadPlugin(editor)}
                                                        />
                                                    </div>
                                                    {errord && <p style={{ color: 'red' }}>{errord}</p>}
                                                </div>
                                                <div className="col-md-6 board_name mt-3 mb-3">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Expiry Date </label>
                                                    <input type="date" className="form-control" id="gradeName2" name='2' min={today} value={tagLastDate} onChange={(e) => setTagLastDate(e.target.value)} />
                                                    {errorT && <p style={{ color: 'red' }}>{errorT}</p>}
                                                </div>
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto new_button">
                                                        {!editId && <button className="btn btn-primary" style={{ marginRight: '20px' }} type="button" onClick={addAnnouncement}>Save</button>
                                                        }                                                        <button className="btn btn-danger delete_icon delete_icon " type="button" style={{ marginRight: "20px" }} onClick={() => { setTagName(''); setTagDescription(''); setTagLastDate(''); setEditId('') }}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateAnnouncement} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Sr. No.</th>
                                                                        <th scope="col">
                                                                            Title
                                                                            <SortIcon sortState={titleSort} setSortState={setTitleSort} setData={setAnnouncementList} setCurrPage={setCurrPage} sortingPath={"title"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Announcements
                                                                            <SortIcon sortState={announcementSort} setSortState={setAnnouncementSort} setData={setAnnouncementList} setCurrPage={setCurrPage} sortingPath={"content"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Date
                                                                            <SortIcon sortState={dateSort} setSortState={setDateSort} setData={setAnnouncementList} setCurrPage={setCurrPage} sortingPath={"createdAt"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Expiry Date
                                                                            <SortIcon sortState={expiryDateSort} setSortState={setExpiryDateSort} setData={setAnnouncementList} setCurrPage={setCurrPage} sortingPath={"expiryDate"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((course, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row">{startIndex + index + 1}</th>
                                                                                        <td>{course.title}</td>
                                                                                        {/* <td>{course.content}</td> */}
                                                                                        <td
                                                                                            style={{
                                                                                                verticalAlign: 'middle', // center vertically
                                                                                                textAlign: 'left',       // align text to the left
                                                                                                padding: '8px',          // optional, for spacing
                                                                                                fontSize: 'inherit',
                                                                                                lineHeight: 'normal',
                                                                                                // color: 'inherit'
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                dangerouslySetInnerHTML={{
                                                                                                    __html: course.content
                                                                                                        .replace(/<\/?p[^>]*>/g, '') // optional: remove <p> tags
                                                                                                        .replace(/style="[^"]*"/g, '') // optional: remove inline styles
                                                                                                }}
                                                                                                style={{
                                                                                                    display: 'inline',    // ensure it stays inline
                                                                                                    margin: 0,
                                                                                                    padding: 0
                                                                                                }}
                                                                                            />
                                                                                        </td>
                                                                                        {/* <td>{moment(course.createdAt).format('DD-MM-YYYY')}</td> */}
                                                                                        <td>{course.createdAt.split(',')[0]}</td>
                                                                                        <td>{moment(course.expiryDate).format('DD-MM-YYYY')}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setTagName(course.title);
                                                                                                setTagDescription(course.content);
                                                                                                setTagLastDate(moment(course.expiryDate).format('YYYY-MM-DD'));
                                                                                                setEditId(course.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === course.id} onClick={() => deleteAnnouncement(course.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No  Announcements Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={announcementList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteAnnouncements;